export const cockpitConstants = {
  COCKPIT_REQUEST: 'COCKPIT_REQUEST',
  COCKPIT_FAILURE: 'COCKPIT_FAILURE',
  COCKPIT_SUCCESS: 'COCKPIT_SUCCESS',
};
